// FILE: src/config/navbarConfig.js
import {
  Home,
  ShoppingCart,
  Plus,
  Activity,
  User,
  Settings,
  MessageSquare,
  Star,
  CreditCard,
  HelpCircle,
  Compass,
  Heart,
  Package,
  DollarSign,
  Search,
  Sprout,
  Utensils,
  BarChart3,
  Leaf,
  Wallet,
  Shield,
  Target,
  Store,
  Bell,
  Globe,
  LogOut,
  PlusCircle,
  X,
  ShoppingBag,
  AreaChart,
  LineChart,
  ChartNoAxesCombined,
  BadgeCheck
} from "lucide-react";


export const actionIcons = {
  Bell,
  Globe,
  LogOut,
  PlusCircle,
  Search,
  X,
  ShoppingBag,
  User,
  MessageSquare,
  Compass,
  Settings,
  Sprout,
  Utensils,
  BarChart3,
  Heart,
  ShoppingCart,
  Home,
  Activity,
  Package,
  Target,
  Wallet,
  HelpCircle,
  Store, 
   LineChart,
   AreaChart,
   ChartNoAxesCombined,
   BadgeCheck,
  Shield
};

const navbarConfig = {
  topLinks: [
    {
      label: "Farm",
      labelKey: "nav.farm",
      to: "/farm",
      Icon: Store, 
      visibleOn: "desktop",
      description: "Browse marketplace",
      priority: 10,
    },
    {
      label: "FarmPulse",
      labelKey: "nav.farmpulse",
      to: "/farmpulse",
      Icon: ChartNoAxesCombined,
      visibleOn: "desktop",
      description: "Agri insights and trends",
      priority: 8,
    },
    {
      label: "FarmMark",
      labelKey: "nav.farmmark",
      to: "/farmmark",
      Icon: BadgeCheck,
      visibleOn: "desktop",
      description: "Crop & soil health, alerts",
      priority: 7,
    },
  ],

  search: {
    id: "search",
    label: "Search",
    labelKey: "nav.search",
    component: "SearchBar",
    visibleOn: "both",
    showWhenAuth: true,
    showWhenGuest: true,
    priority: 200,
    ariaLabel: "Search marketplace",
    Icon: Search,
  },

  bottomNav: [
    {
      id: "farm",
      label: "Farm",
      labelKey: "nav.farm",
      to: "/farm",
      Icon: Store,
      visibleOn: "both",
      showWhenAuth: true,
      showWhenGuest: true,
      badgeKey: null,
      priority: 50,
    },
    {
      id: "post",
      label: "Create",
      labelKey: "nav.create",
      action: "create",
      createOptions: [
        { id: "product", label: "Sell Product", route: "/sellnow" },
      ],
      Icon: PlusCircle,
      visibleOn: "both",
      showWhenAuth: true,
      showWhenGuest: false,
      priority: 100,
      ariaLabel: "Create new product",
    },
    {
      id: "farmpulse",
      label: "FarmPulse",
      labelKey: "nav.farmpulse",
      to: "/farmpulse",
      Icon: BarChart3,
      visibleOn: "both",
      showWhenAuth: true,
      showWhenGuest: true,
      priority: 30,
    },
    {
      id: "farmmark",
      label: "FarmMark",
      labelKey: "nav.farmmark",
      to: "/farmmark",
      Icon: BadgeCheck,
      visibleOn: "both",
      showWhenAuth: true,
      showWhenGuest: true,
      priority: 35,
    },
    {
      id: "me",
      label: "Me",
      labelKey: "nav.me",
      to: "/me",
      Icon: User,
      visibleOn: "both",
      showWhenAuth: true,
      showWhenGuest: false,
      badgeKey: "unreadNotifications",
      priority: 20,
    },
  ],

  languages: [
    { code: "en", label: "English" },
    { code: "rw", label: "Kinyarwanda" },
  ],

  meLinks: [
    {
      id: "profile",
      label: "Profile",
      labelKey: "me.profile",
      to: "/profile/:uid",
      Icon: User,
      description: "View and edit your public profile",
      showWhenAuth: true,
      priority: 100,
    },
    {
      id: "farmmark",
      label: "Impact",
      labelKey: "me.impact",
      to: "/farmmark",
      Icon: Target,
      description: "Your impact, timeline and points",
      showWhenAuth: true,
      priority: 90,
    },
    {
      id: "offerManager",
      label: "Offer Manager",
      labelKey: "me.offers",
      to: "/offers",
      Icon: MessageSquare,
      description: "Offers you've received or sent",
      showWhenAuth: true,
      badgeKey: "offersCount",
      priority: 80,
    },
    {
      id: "myProducts",
      label: "My Products",
      labelKey: "me.products",
      to: "/my-products",
      Icon: Package,
      description: "Products you have listed for sale",
      showWhenAuth: true,
      priority: 75,
    },
    {
      id: "balance",
      label: "Balance",
      labelKey: "me.balance",
      to: "/balance",
      Icon: Wallet,
      description: "Wallet & payments (coming soon)",
      showWhenAuth: true,
      priority: 65,
    },
    {
      id: "settings",
      label: "Settings",
      labelKey: "me.settings",
      to: "/settings",
      Icon: Settings,
      description: "App preferences",
      showWhenAuth: true,
      priority: 55,
    },
    {
      id: "help",
      label: "Help Center",
      labelKey: "me.help",
      to: "/support",
      Icon: HelpCircle,
      description: "Support & FAQs",
      showWhenAuth: true,
      showWhenGuest: true,
      priority: 50,
    },
    {
      id: "northstar",
      label: "NorthStar",
      labelKey: "me.northstar",
      to: "/north-star",
      Icon: Compass,
      description: "Vision & product story",
      showWhenAuth: true,
      showWhenGuest: true,
      priority: 40,
    },
  ],

  // Reference the exported actionIcons
  actionIcons: actionIcons
};

// Export utility functions
export function resolveTo(to, uid) {
  if (!to) return null;
  if (typeof to !== "string") return to;
  if (to.includes(":uid")) {
    return to.replace(":uid", uid || "");
  }
  return to;
}

export function filterNavItems(items = [], opts = {}) {
  const { user = null, isMobile = false, profile = {} } = opts;
  return (items || [])
    .filter((it) => {
      if (it.visibleOn === "mobile" && !isMobile) return false;
      if (it.visibleOn === "desktop" && isMobile) return false;

      if (it.showWhenAuth === true && !user) return false;
      if (it.showWhenGuest === true && user) return false;

      if (Array.isArray(it.roles) && it.roles.length > 0) {
        const role = (user && (user.role || profile.role)) || null;
        if (!role || !it.roles.includes(role)) return false;
      }

      return true;
    })
    .sort((a, b) => (b.priority || 0) - (a.priority || 0));
}

export default navbarConfig;